document.addEventListener("DOMContentLoaded", (event) => {
  const targetNode = document.querySelector(".quick-product-modal ");
  const config = { attributes: true };
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "data-quick-product-type"
      ) {
        setTimeout(() => {
          BSS_B2B.observer.productSubject.notifyObserver(
            "ProductMutate",
            "ProductPriceMutate"
          );
        }, 2000);
      }
    }
  };
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
});
